import { motion } from "framer-motion";

export const PageLoader = ({ label = "Verificando sua sessão", testid = "page-loader" }) => (
  <div data-testid={testid} className="flex min-h-screen flex-col items-center justify-center bg-[#050505] text-zinc-100">
    <div className="relative flex h-20 w-20 items-center justify-center">
      <motion.span
        aria-hidden="true"
        animate={{ rotate: 360 }}
        transition={{ duration: 1.4, repeat: Infinity, ease: "linear" }}
        className="absolute inset-0 rounded-full border border-[#22222A] border-t-[#E50914]"
      />
      <motion.span
        aria-hidden="true"
        animate={{ rotate: -360 }}
        transition={{ duration: 2.2, repeat: Infinity, ease: "linear" }}
        className="absolute inset-2 rounded-full border border-dashed border-[#E50914]/30"
      />
      <span className="font-display text-sm font-extrabold tracking-tight">
        L<span className="text-[#E50914]">.</span>
      </span>
    </div>
    <p className="mt-6 font-mono-code text-[10px] uppercase tracking-[0.35em] text-zinc-500">{label}</p>
  </div>
);
